<template>
  <div :class="$style.container">
    <div :class="[$style.container__header, $style.header]">
      <p :class="$style.header__title">{{ title }}</p>
      <ButtonClose @click="$emit('close')" />
    </div>
    <div :class="$style.body">
      <slot />
    </div>
    <div :class="[$style.container__footer, $style.footer]">
      <FlatButton
        :variant="buttonVariant"
        @click="$emit('confirm')"
        :disabled="disabled"
      >
        {{ buttonText }}
      </FlatButton>
    </div>
  </div>
</template>

<script lang="ts">
export type { Variant } from '@/components/atoms/FlatButton.vue'
</script>

<script lang="ts" setup>
import ButtonClose from '@/components/atoms/ButtonClose.vue'
import type { Variant } from '@/components/atoms/FlatButton.vue'
import FlatButton from '@/components/atoms/FlatButton.vue'

withDefaults(
  defineProps<{
    title: string
    buttonText: string
    buttonVariant?: Variant
    disabled?: boolean
  }>(),
  { buttonVariant: 'primary', disabled: false }
)

defineEmits<{
  (event: 'confirm'): void
  (event: 'close'): void
}>()
</script>

<style lang="scss" module>
.container {
  background-color: $color-surface-primary;
  border-radius: $border-radius-v2-rounder;

  &__footer {
    align-items: center;
    padding: 12px 0;
  }
}

.header {
  display: flex;
  padding: 16px 24px;
  font-weight: bold;

  &__title {
    flex: auto;
  }
}

.body {
  padding: 24px 100px;
  border-top: $color-border-low-emphasis 1px solid;
  text-align: center;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: $color-border-low-emphasis 1px solid;
}
</style>
